import React from 'react';
import { convertISOToDateTimeFormat } from '../../../../util/timezone';
import style from './index.scss';

function ThresholdValueCard({ value }) {
  if (value.length === 0) {
    return '-';
  }

  const isISODate = (value) => typeof value === 'string' && value.includes('T');

  const isNumber = (value) => typeof value === 'number' && !isNaN(value);

  return (
    <div className={style.thresholdValueCard}>
      {value.map((item, index) => (
        <div key={index}>
          <div style={{ width: '45%' }}>
            <p style={{ margin: '0', display: 'flex', gap: '14px' }}>
              <span>{item.key}</span>
              <span></span>
            </p>
            <p style={{ margin: '0', display: 'flex', gap: '14px' }}>
              <span></span>
              <span></span>
            </p>
            <p style={{ margin: '0', display: 'flex', gap: '14px' }}>
              <span></span>
              <span></span>
            </p>
          </div>
          <div
            style={{
              border: '1px solid #d4d4d4',
              borderRight: '0',
              borderTop: '0',
              borderBottom: '0',
              paddingLeft: '30px',
              marginLeft: '10px'
            }}>
            <p style={{ margin: '0', fontWeight: 'bold' }}>
              {Array.isArray(item.value)
                ? item.value.map((m, i) => (
                    <p style={{ marginBottom: 0 }} key={`m-${i}`}>
                      {m}
                      {i !== item.value.length - 1 ? ',' : ''}
                    </p>
                  ))
                : isISODate(item.value)
                ? convertISOToDateTimeFormat(item.value)
                : isNumber(item.value)
                ? item.value.toFixed(2)
                : typeof item.value === 'boolean'
                ? item.value.toString()
                : item.value}
            </p>
            <p style={{ margin: '0', fontWeight: 'bold' }}></p>
            <p style={{ margin: '0', fontWeight: 'bold' }}></p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ThresholdValueCard;
